class BurgerMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.burgerMenu = this.querySelector(".burger-menu");
    this.openButton = this.querySelector(".burger-menu__toggle--open-btn");
    this.openhoverButton = this.querySelector(".burger-menu__hover--open-btn");
    this.closeButton = this.querySelectorAll(".burger-menu__toggle--close-btn");
    this.overlay = this.querySelector(".burger-menu__overlay");
    this.headerHadColorBackground2 = false;
    this.headerHadColorBackground1 = false;
    this.activeElement = null;
    this._closeTimeout = null;
    this._overlayFadeTimeout = null;

    if (this.header) this.header.preventHide = false;

    this.setListeners();
    this.initCategoryTabs();
    this.initScrollGradients();
  }

  getHeaderColorClasses(headerElement) {
    if (headerElement && headerElement.hasAttribute('data-header-color-scheme-light')) {
      const currentScheme = document.documentElement.getAttribute('data-scheme');
      const isDark = currentScheme === 'dark' || (currentScheme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);
      const schemeId = isDark
        ? headerElement.getAttribute('data-header-color-scheme-dark')
        : headerElement.getAttribute('data-header-color-scheme-light');
      return {
        solid: `color-${schemeId}`,
        transparent: 'color-background-2'
      };
    }
    return {
      solid: 'color-background-1',
      transparent: 'color-background-2'
    };
  }

  clearCloseTimeouts() {
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
    }
    if (this._overlayFadeTimeout) {
      clearTimeout(this._overlayFadeTimeout);
      this._overlayFadeTimeout = null;
    }
  }

  open(event) {
    event.preventDefault();
    this.clearCloseTimeouts();
    if (this.header) this.header.preventHide = true;

    const triggerElement = document.activeElement;

    const otherMenu = document.querySelector(".burger-menu--open");
    if (otherMenu) {
      this.close(event);
      otherMenu.classList.remove("burger-menu--open");
      otherMenu.querySelector(".burger-menu__overlay")?.classList?.remove("burger-menu__overlay--active");
      setTimeout(function () {
        this.activeElement = triggerElement;
        this.burgerMenu.classList.add("burger-menu--open");
        if (!this.classList.contains('mobile-burger-menu')) {
          this.overlay.classList.add("burger-menu__overlay--active");
        }
        document.body.classList.add("overflow-hidden-drawer");
        this.setDropdownWrapperPosition(this);
        this.updateToggleButton(true);
        this.updateHeaderStyles(true);
        if (this.dataset.openOnHover !== 'true') {
          const wrapper = this.querySelector('#BurgerMenuWrapper') || this.querySelector('.burger-menu__wrapper');
          if (wrapper) trapFocus(wrapper, wrapper);
        }
      }.bind(this), 1000);
    }

    this.activeElement = triggerElement;

    this.burgerMenu.classList.add("burger-menu--open");
    if (!this.classList.contains('mobile-burger-menu')) {
      this.overlay.classList.add("burger-menu__overlay--active");
    }
    document.body.classList.add("overflow-hidden-drawer");
    this.setDropdownWrapperPosition(this);
    this.updateToggleButton(true);
    this.updateHeaderStyles(true);
    if (this.dataset.openOnHover !== 'true') {
      const wrapper = this.querySelector('#BurgerMenuWrapper') || this.querySelector('.burger-menu__wrapper');
      if (wrapper) trapFocus(wrapper, wrapper);
    }
  }

  close(event) {
    event.preventDefault();
    this.clearCloseTimeouts();

    this.burgerMenu.classList.remove("burger-menu--open");

    document.body.classList.remove("overflow-hidden-drawer");

    if (this.header) this.header.preventHide = false;

    this.burgerMenu.classList.add("hiding");

    if (this.dataset.openOnHover === 'true') {
      if (!this.classList.contains('mobile-burger-menu')) {
        this.overlay?.classList.remove("burger-menu__overlay--active");
      }
      this.burgerMenu.classList.remove("hiding");
    } else {
      this._closeTimeout = setTimeout(() => {
        if (!this.classList.contains('mobile-burger-menu')) {
          this.overlay?.classList.remove("burger-menu__overlay--active");
          this._overlayFadeTimeout = setTimeout(() => {
            this.burgerMenu.classList.remove("hiding");
            this._overlayFadeTimeout = null;
          }, 300);
        } else {
          this.burgerMenu.classList.remove("hiding");
        }
        this._closeTimeout = null;
      }, 700);
    }

    this.clearDropdownWrapperPosition();
    this.updateToggleButton(false);
    this.updateHeaderStyles(false);

    if (this.dataset.openOnHover !== 'true') {
      removeTrapFocus(this.activeElement);
      this.activeElement = null;
    }
  }

  updateToggleButton(isOpen) {
    if (!this.classList.contains('mobile-burger-menu')) return;

    if (this.openButton) {
      const ariaLabelOpen = this.openButton.getAttribute('data-aria-label-open');
      const ariaLabelClose = this.openButton.getAttribute('data-aria-label-close');

      if (isOpen && ariaLabelClose) {
        this.openButton.setAttribute('aria-label', ariaLabelClose);
      } else if (!isOpen && ariaLabelOpen) {
        this.openButton.setAttribute('aria-label', ariaLabelOpen);
      }

      this.openButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  updateHeaderStyles(isOpen) {
    if (!this.classList.contains('mobile-burger-menu')) return;

    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    if (header.classList.contains("entering-section")) {
      header.classList.add("drawer-transitioning");
      clearTimeout(this._drawerTransitionTimeout);
      this._drawerTransitionTimeout = setTimeout(() => header.classList.remove("drawer-transitioning"), 600);
    }

    const classes = this.getHeaderColorClasses(header);

    if (isOpen) {
      this.headerHadColorBackground2 = header.classList.contains(classes.transparent) || header.classList.contains("color-background-2");
      this.headerHadColorBackground1 = header.classList.contains(classes.solid) || header.classList.contains("color-background-1");

      if (this.headerHadColorBackground2) {
        header.classList.remove(classes.transparent, "color-background-2");
      }

      if (!header.classList.contains(classes.solid) && !header.classList.contains("color-background-1")) {
        header.classList.add(classes.solid);
      }

      this.classList.add("burger-menu-open");
      this.updateHeaderPosition();
    } else {
      const main = document.querySelector("main");
      const isSticky = header.classList.contains("shopify-section-header-sticky");

      if (isSticky) {
        if (
          !main
            .querySelectorAll(".shopify-section")[0]
            ?.classList.contains("section--has-overlay")
        ) {
          if (this.headerHadColorBackground2) {
            header.classList.add(classes.transparent);
          }
        }
      } else {
        if (
          main
            .querySelectorAll(".shopify-section")[0]
            ?.classList.contains("section--has-overlay") &&
          !header.classList.contains("animate")
        ) {
          header.classList.add(classes.solid, classes.transparent);
        } else if (this.headerHadColorBackground2) {
          header.classList.add(classes.transparent);
          if (!this.headerHadColorBackground1) {
            header.classList.remove(classes.solid, "color-background-1");
          }
        } else if (!this.headerHadColorBackground1) {
          header.classList.remove(classes.solid, "color-background-1");
        }
      }

      this.headerHadColorBackground2 = false;
      this.headerHadColorBackground1 = false;

      this.classList.remove("burger-menu-open");
      this.resetHeaderPosition();
    }
  }

  updateHeaderPosition() {
    if (!this.header || !this.classList.contains('mobile-burger-menu')) return;

    const countdownHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--countdown-bar-height')
    ) || 0;

    if (countdownHeight > 0) {
      this.header.style.transform = `translateY(-${countdownHeight}px)`;
    }
  }

  resetHeaderPosition() {
    if (!this.header || !this.classList.contains('mobile-burger-menu')) return;

    this.header.style.transform = '';
  }

  setListeners() {
    if (this.dataset.openOnHover === 'true') {
      this.openhoverButton?.addEventListener("mouseenter", (event) => {
        this.open(event);
      });
      this?.addEventListener("mouseleave", (event) => this.close(event));
    }

    // For mobile burger menu, toggle open/close on the same button
    if (this.classList.contains('mobile-burger-menu')) {
      this.openButton?.addEventListener("click", (event) => {
        if (this.burgerMenu.classList.contains("burger-menu--open")) {
          this.close(event);
        } else {
          this.open(event);
        }
      });
    } else {
      this.openButton?.addEventListener("click", (event) => this.open(event));
    }

    this.closeButton?.forEach((item) =>
      item.addEventListener("click", (event) => this.close(event))
    );
    // Overlay click only works on desktop (mobile has pointer-events: none)
    if (!this.classList.contains('mobile-burger-menu')) {
      this.overlay?.addEventListener("click", (event) => this.close(event));
    }
    this.burgerMenu?.addEventListener(
      "keyup",
      (event) => event.code === "Escape" && this.close(event)
    );
  }

  setDropdownWrapperPosition(el) {
    const dropdownWrapper = el.querySelector('.burger-menu__dropdown-wrapper');
    if (!dropdownWrapper) return;

    const header = document.querySelector(".shopify-section-header");
    const burgerMenu = el.querySelector(".burger-menu");
    const burgerMenuOverlay = el.querySelector(".burger-menu__overlay");
    const calcTranslatePosition = `${this.getElementHeight(header)}px`;

    if (this.dataset.openOnHover === 'true') {
      dropdownWrapper.style.opacity = 1;
    }

    dropdownWrapper.style.transform = `translateY(0)`;
    burgerMenu.style.top = calcTranslatePosition;
    burgerMenuOverlay.style.top = calcTranslatePosition;
  }

  clearDropdownWrapperPosition() {
    const dropdownWrappers = document.querySelectorAll('.burger-menu__dropdown-wrapper');
    dropdownWrappers?.forEach((el) => {
      const header = document.querySelector(".shopify-section-header");
      const announcement = document.querySelector(".section-announcement");
      const countdownTimerBar = document.querySelector(".section-countdown-timer-bar");

      const calcTranslatePosition = this.getElementHeight(header) + this.getElementHeight(announcement) + this.getElementHeight(countdownTimerBar);
      el.style.transform = `translateY(calc(-100% - ${calcTranslatePosition}px))`;

      if (el.classList.contains('burger-menu__on-hover')) {
        el.style.opacity = 0;
      }

      const burgerMenu = el.closest(".burger-menu");
      const burgerMenuOverlay = el.previousElementSibling;
      if (burgerMenu) {
        burgerMenu.style.top = 0;
      }
      if (burgerMenuOverlay) {
        burgerMenuOverlay.style.top = 0;
      }
    });
  }

  getElementHeight(el) {
    if (!el) return 0;

    // For countdown timer bar, use CSS variable which is updated by IntersectionObserver
    // This handles cases where the bar is partially visible
    if (el.classList.contains('section-countdown-timer-bar')) {
      const countdownHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--countdown-bar-height')
        .trim();
      if (countdownHeight && countdownHeight !== '0px') {
        return parseFloat(countdownHeight);
      }
    }

    // For other elements, check if they're in viewport
    if (this.isElementInViewport(el)) {
      return el?.getBoundingClientRect()?.height || 0;
    }

    // If element is partially visible, return the visible height
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      // Element is partially visible, calculate visible height
      const visibleTop = Math.max(0, rect.top);
      const visibleBottom = Math.min(window.innerHeight, rect.bottom);
      return Math.max(0, visibleBottom - visibleTop);
    }

    return 0;
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0
    );
  }

  initScrollGradients() {
    const top = this.querySelector('.burger-menu__top');
    if (!top) return;

    const update = () => {
      const isScrollable = top.scrollHeight > top.clientHeight;
      const atTop = top.scrollTop <= 1;
      const atBottom = top.scrollTop + top.clientHeight >= top.scrollHeight - 1;

      top.classList.toggle('burger-menu__top--scroll-down', isScrollable && !atBottom);
      top.classList.toggle('burger-menu__top--scroll-up', isScrollable && !atTop);
    };

    top.addEventListener('scroll', update, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(top);
    }

    update();
  }

  initCategoryTabs() {
    // Only initialize for mobile burger menu
    if (!this.classList.contains('mobile-burger-menu')) return;

    const tabs = this.querySelectorAll('.burger-menu__category-tab');
    const contents = this.querySelectorAll('.burger-menu__category-content');

    if (tabs.length === 0 || contents.length === 0) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        const categoryIndex = tab.getAttribute('data-category-index');

        // Remove active class from all tabs and contents
        tabs.forEach((t) => t.classList.remove('active'));
        contents.forEach((c) => c.classList.remove('active'));

        // Add active class to clicked tab and corresponding content
        tab.classList.add('active');
        const targetContent = this.querySelector(
          `.burger-menu__category-content[data-category-index="${categoryIndex}"]`
        );
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  }
}

if (!customElements.get("burger-menu")) {
  customElements.define("burger-menu", BurgerMenu);
}
